import { FC } from 'react'
import { LoginMethodFormBlockProps } from 'src/components/LoginMethodFormBlock'

import { MainLayoutProps } from '../../layouts'
import { BannerBlockLeftRightProps } from '../../components/BannerBlockLeftRight'
import { LoginFormBlockProps } from '../../components/LoginFormBlock'
import { RegisterFormProps } from '../../forms/RegisterForm'

import * as SC from './styled'

export type LoginRegisterTemplateProps = MainLayoutProps & {
  title: string
  bannerTextActions?: BannerBlockLeftRightProps
  loginFormBlock?: LoginFormBlockProps
  registerForm?: RegisterFormProps
  loginMethodForm?: LoginMethodFormBlockProps
}

const LoginRegisterTemplate: FC<LoginRegisterTemplateProps> = ({
  title,
  bannerTextActions,
  loginFormBlock,
  registerForm,
  loginMethodForm,
  ...layout
}) => {
  return (
    <SC.Layout {...layout}>
      <SC.Wrapper>
        <SC.Crosses icon="crosses" width={100} />
        {title && <SC.PageTitle>{title}</SC.PageTitle>}
        {bannerTextActions && <SC.Banner {...bannerTextActions} />}
        {loginMethodForm && <SC.LoginMethodFormStyled {...loginMethodForm} />}
        {loginFormBlock && <SC.LoginFormStyled {...loginFormBlock} />}
        {registerForm && <SC.RegisterFormStyled {...registerForm} />}
      </SC.Wrapper>
    </SC.Layout>
  )
}

export default LoginRegisterTemplate
